import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { CanActivateFn, Router } from '@angular/router';
import { filter, map, take } from 'rxjs';
import { NtaFacilityStore } from './facility.store';

export type NtaFacilityFeature = 'SIMPLIMDS' | 'SIMPLIROUNDS' | 'SIMPLIADR';

const FEATURE_ROUTES: Record<NtaFacilityFeature, string> = {
	SIMPLIMDS: 'simplimds',
	SIMPLIROUNDS: 'simplirounds',
	SIMPLIADR: 'simpliadr',
};

const FEATURE_FALLBACK_ORDER: NtaFacilityFeature[] = ['SIMPLIMDS', 'SIMPLIROUNDS', 'SIMPLIADR'];

export const featureEnabledGuard = (feature: NtaFacilityFeature): CanActivateFn => () => {
	const store = inject(NtaFacilityStore);
	const router = inject(Router);

	const isEnabled: Record<NtaFacilityFeature, () => boolean> = {
		SIMPLIMDS: () => store.simpliMDSEnabled(),
		SIMPLIROUNDS: () => store.simpliroundsEnabled(),
		SIMPLIADR: () => store.simpliADREnabled(),
	};

	return toObservable(store.facilityLoaded).pipe(
		filter((facilityLoaded) => facilityLoaded),
		take(1),
		map(() => {
			if (isEnabled[feature]()) return true;

			const fallback = FEATURE_FALLBACK_ORDER.find((f) => f !== feature && isEnabled[f]());
			if (fallback) return router.parseUrl(`/${FEATURE_ROUTES[fallback]}`);
			return router.parseUrl('/account/unauthorized');
		})
	);
};
